import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida
import type { ICitaTabxcomponents, ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { IFormularios } from '@/modules/Configuracion/interfaces/IFormComponent'
import type { ITechnologiaHistory } from '../interfaces/tablas/ICitaTechnologiasSalud'
import type { IConfMotivos } from '@/modules/Configuracion/interfaces/tablas/IConfMotivos'
export class FormCompValueService extends BaseService<ICitaTabxcomponents> {
  constructor () {
    super({
      baseUrl: 'scheduling/historys/'
    })
  }
  async document (
    id: number,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ICitaTechnologiasSalud>>> {
    return this.http.get<IResponseApi<ICitaTechnologiasSalud>>(
      `/view/${id}`, { params }
    ).catch(error => this.errorHandle(error))
  }
  async historyComponent (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ITechnologiaHistory[]>>> {
    return this.http.get<IResponseApi<ITechnologiaHistory[]>>(
      `/history-component`, { params }
    ).catch(error => this.errorHandle(error))
  }
  async saveDocument (
    id: number,
    data: IFormularios | Uint8Array
  ): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.post<IResponseApi<boolean>>(
      `/save-history/${id}`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Content-Encoding': 'gzip',
        },
        transformRequest: [(d) => d]
      }
    ).catch(error => this.errorHandle(error))
  }

  async clearHistory (
    id: number | string,
    body: IConfMotivos
  ): Promise<AxiosResponse<IResponseApi<IConfMotivos>>> {
    return this.http.post<IConfMotivos>(`/clear/${id}`, body).catch(this.errorHandle)
  }
}
